export const requests = (state) => {
  return state.requests
}
